<template>
	<div>
		<label>
			<input
				type="checkbox"
				class="CheckboxInput"
				:value="optionValue"
				:data-filter="filterKey"
				v-model="selectedOptions"
				@click="setSelectedOptions()"
			>
			<span>{{ optionName }}</span>
			<span v-if="displayFacets" class="Facet">{{ facet }}</span>
			<slot name="ExpandCollapseToggle"></slot>
		</label>
	</div>
</template>

<script lang="ts" src="./Checkbox.ts"></script>
<style lang="scss" scoped src="./Checkbox.scss"></style>
